export default __webpack_public_path__ + "static/media/featuredSportMobile.73ac3e6a.png";